class WardrobeFooter2 {
  constructor(section) {
    this.section = section;
    this.triggers = Array.from(
      section.querySelectorAll(".wardrobe-footer-2__accordion-trigger")
    );

    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const contentId = trigger.getAttribute("aria-controls");
        const content = this.section.querySelector(`#${CSS.escape(contentId)}`);

        if (!content) return;

        const isOpen = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", String(!isOpen));
        content.classList.toggle("is-open", !isOpen);
      });
    });
  }
}

function initWardrobeFooter2(scope = document) {
  scope.querySelectorAll(".wardrobe-footer-2").forEach((section) => {
    if (section.dataset.wardrobeFooterInitialized === "true") return;

    section.dataset.wardrobeFooterInitialized = "true";
    new WardrobeFooter2(section);
  });
}

document.addEventListener("DOMContentLoaded", () => initWardrobeFooter2());

document.addEventListener("shopify:section:load", (event) => {
  initWardrobeFooter2(event.target);
});
